import {
    FlightDate,
    TravelProductInformation,
} from '@models/travelproductinfo.model';

export class SellRecommendationQuery {

    itineraryDetails: Array<ItineraryInfo> = [];

    prepareSellRequest(model: SellRecommendationQuery, params, flightObj, originDestinationOptions = null) {

        let flightDetails: any = [];
        let segIndex = 0;
        let totalduration: string;
        let originDestinationCheckAvailabilityOptions = null;
        let supplierCode: string;

        if (params['tripType'] == 'OneWay' || params['tripType'] == 'RoundTrip') {
            flightDetails = flightObj.depflight.flightDetails;
            totalduration = flightObj.depflight.totalTravelDuration;
            if (originDestinationOptions && Array.isArray(originDestinationOptions) && originDestinationOptions.length > 0) {
                originDestinationCheckAvailabilityOptions = originDestinationOptions[0].flightSegment;
            }
            supplierCode = flightObj.depflight.supplierCode;
            params = { ...params, supplierCode };
            segIndex = this.prepareSegmentInfo(model, flightDetails, flightObj, params, segIndex, totalduration, originDestinationCheckAvailabilityOptions);
        }



        if (params['tripType'] == 'MultiCity') {
            let classDesignator = flightObj[flightObj.length - 1].bookingClassDesignator;
            let reservationDesignator = flightObj[flightObj.length - 1].reservationDesignator;
            let seatDesignator = { 'bookingClass': classDesignator, 'reservationClass': reservationDesignator };
            supplierCode = flightObj[0].depflight.supplierCode;
            params = { ...params, supplierCode };
            for (const [i, flight] of flightObj.entries()) {
                flightDetails = flight.depflight.flightDetails;
                totalduration = flight.depflight.totalTravelDuration;
                if (originDestinationOptions && Array.isArray(originDestinationOptions) && originDestinationOptions.length > 0) {
                    originDestinationCheckAvailabilityOptions = originDestinationOptions[i].flightSegment;
                }
                segIndex = this.prepareSegmentInfo(model, flightDetails, flight, params, segIndex, totalduration, originDestinationCheckAvailabilityOptions, seatDesignator);
            }
        }


        if (flightObj.arrivalflight != undefined) {
            let flightDetails = flightObj.arrivalflight.flightDetails;
            totalduration = flightObj.arrivalflight.totalTravelDuration;
            if (originDestinationOptions && Array.isArray(originDestinationOptions) && originDestinationOptions.length > 0) {
                originDestinationCheckAvailabilityOptions = originDestinationOptions[1].flightSegment;
            }
            supplierCode = flightObj.depflight.supplierCode;
            params = { ...params, supplierCode };
            segIndex = this.prepareSegmentInfo(model, flightDetails, flightObj, params, segIndex, totalduration, originDestinationCheckAvailabilityOptions);
        }

        return this.itineraryDetails;
    }

    prepareSegmentInfo(model, flightDetails: any[], flightObject, searchParams, segIndex, totalduration: string, originDestinationOptions, classDesg = null) {

        let segmentsArray: Array<TravelProductInformation> = [];
        let origin: string;
        let destination: string;
        let totalTravelDuration: string = totalduration;

        flightDetails.forEach((item, index) => {
            segIndex++;
            let productInfo = new TravelProductInformation();
            let flightDate = new FlightDate();

            flightDate.departureDate = item.dateOfDeparture;
            flightDate.departureTime = item.timeOfDeparture;
            flightDate.arrivalDate = item.dateOfArrival;
            flightDate.arrivalTime = item.timeOfArrival;

            productInfo.isDifferentFromLocation = item.isDifferentFromLocation;
            productInfo.segmentSequence = segIndex;
            productInfo.flightDate = flightDate;
            productInfo.operatingCarrier = item.operatingCarrier;
            productInfo.marketingCarrier = item.marketingCarrier;
            productInfo.flightNumber = item.flightNumber;
            productInfo.flightName = item.airlineName || '';
            productInfo.duration = item.duration;

            if (searchParams.tripType == 'OneWay') {
                productInfo.bookingClassDesignator = flightObject.depflight.fareDetails.bookingClassDesignator;
                if (flightObject.depflight.fareDetails.reservationBookingDesignator != null) {
                    productInfo.reservationBookingDesignator = flightObject.depflight.fareDetails.reservationBookingDesignator[segIndex - 1];
                } else {
                    productInfo.reservationBookingDesignator = null;
                }


            } else if (searchParams.tripType == 'RoundTrip') {
                productInfo.bookingClassDesignator = flightObject.arrivalflight.fareDetails.bookingClassDesignator;
                if (flightObject.arrivalflight.fareDetails.reservationBookingDesignator != null) {
                    productInfo.reservationBookingDesignator = flightObject.arrivalflight.fareDetails.reservationBookingDesignator[segIndex - 1];
                } else {
                    productInfo.reservationBookingDesignator = null;
                }

            } else {
                productInfo.bookingClassDesignator = classDesg.bookingClass;
                if (classDesg.reservationClass != null) {
                    productInfo.reservationBookingDesignator = classDesg.reservationClass[segIndex - 1];
                } else {
                    productInfo.reservationBookingDesignator = null;
                }
            }

            if (originDestinationOptions) {
                productInfo.bookingClass = (searchParams.supplierCode === 'SB') ? originDestinationOptions[index].resBookDesigCode : item.bookingClass;
                // productInfo.marriageGrp = (searchParams.supplierCode === 'SB') ? originDestinationOptions[index].marriageGrp : '';
            } else {
                productInfo.bookingClass = item.bookingClass;
            }

            productInfo.departureAirportCode = item.fromLocation;
            productInfo.arrivalAirportCode = item.toLocation;
            productInfo.marriageGrp = item.marriageGrp;
            segmentsArray.push(productInfo);

            if (index == 0) {
                origin = item.fromLocation;
            }

            if (flightDetails.length - 1 == index) {
                destination = item.toLocation;
                let itineraryInfo = new ItineraryInfo();
                itineraryInfo.segmentInformation = segmentsArray;
                itineraryInfo.origin = origin;
                itineraryInfo.destination = destination;
                itineraryInfo.totalDuration = totalTravelDuration;
                this.itineraryDetails.push(itineraryInfo);
            }

        });
        return segIndex;
    }

}

export class ItineraryInfo {
    origin: string;
    destination: string;
    totalDuration: string;
    segmentInformation: Array<TravelProductInformation> = [];
}